import { createContext, ReactNode } from "react";

export type AppModalContextType = {
  isOpen: boolean;
  onCloseModal(): void;
  onOpenModal(content: ReactNode): void;
};

export const AppModalContext = createContext<AppModalContextType | null>(null);
